// =================================================================================================
// >>> **WHAT SHE ACTUALLY PAYS, WHICH IS NOT WHAT THE PAGE HAS BEEN SHOWING HER.** <<<
// (her order, 2026-09-05)
//
// **THE MEMBER WHO PROVED IT.** `chesson.cinchonia@yahoo.com` was corrected to $80 a month, told so,
// and wrote back within two and a half hours: *"But in my thing it shows 149."* She was reading her
// own membership page, and it was showing her the STICKER — the price of the Vet tier for somebody
// who does not hold what she holds. Her bill was right the whole time; the page was frightening her
// about a number she was never going to be charged.
//
// **87 ELITE MEMBERS ARE IN THAT POSITION RIGHT NOW.** Each holds a permanent $69 Apprentice grant
// and pays $149 minus it, and every one of them sees $149 on the page.
//
// ---------------------------------------------------------------------------------------------
// >>> **THE PAGE AND THE BILL AGREE BY CONSTRUCTION, NOT BY A LIVE CHECK.** <<<
//
// Her clause is *"verify against Stripe's invoice preview so the page and the bill always agree"*,
// and the strongest way to satisfy it is not to ask Stripe on every page load — it is to compute the
// rate with **THE SAME LAW THAT SET THE COUPON**. `grantUpgradeCredit` prices the checkout, priced
// the sweep that corrected all 87 subscriptions, and prices this line. Three readers, one law
// (R28/R29), so they cannot drift into two answers about a woman's money.
//
// **AND IT WAS VERIFIED AGAINST THE REAL INVOICE ANYWAY**, on the member who complained: Stripe's
// own preview of her next bill reads subtotal $149.00, discount $69.00, total **$80.00** on 14
// September — which is exactly what this law returns for her.
//
// **IT IMPORTS ONLY THE LADDER**, so a fixture can drive every state of it with no database.
// =================================================================================================
import { tierByKey, grantUpgradeCredit, grantUpgradeDue } from "../server/tiers.js";

/**
 * >>> **HER REAL MONTHLY RATE, OR NOTHING.** <<<
 *
 * **`null` IS THE ANSWER FOR ALMOST EVERYBODY, AND THAT IS THE POINT (R18).** A member with no grant
 * behind her paid tier pays the sticker, and the sticker is already on the page — printing "your
 * rate is $149" beside a card that says $149 is noise that teaches her to stop reading the line.
 * This speaks ONLY where the two differ.
 *
 * It also answers `null` for a grant that does not reduce the paid tier at all — a Newbie grant
 * behind a Newbie subscription earns nothing, and `grantUpgradeCredit` already refuses a sideways
 * or downward step, so this inherits that ruling rather than restating it.
 */
export function memberRate({ paidTier = "", grantTier = "" } = {}) {
  const paid = tierByKey(String(paidTier || ""));
  if (!paid) return null;
  const credit = grantUpgradeCredit({ heldTier: String(grantTier || ""), targetTier: paid.key });
  if (!(credit > 0)) return null;
  const rate = grantUpgradeDue({ heldTier: String(grantTier || ""), targetTier: paid.key });
  const held = tierByKey(String(grantTier || ""));
  return {
    tier: paid.key,
    sticker: Number(paid.price) || 0,
    credit,
    rate,
    heldTier: held ? held.key : "",
    heldLabel: held ? held.label : "",
  };
}

/**
 * **THE LINE SHE READS, AND IT NAMES THE CREDIT RATHER THAN JUST THE NUMBER.**
 *
 * A page that quietly showed $80 would be correct and still leave her wondering whether it was a
 * mistake that would be taken back. The sentence says WHY it is $80, so the number carries its own
 * explanation — which is what stops the next woman writing in frightened.
 *
 * **NO RATE, NO SENTENCE.** An empty string rather than a hedge, so a surface renders nothing at all
 * rather than a line about a discount she does not have.
 */
export function memberRateLine(rate, { source = "Elite" } = {}) {
  if (!rate) return "";
  const money = (n) => `$${Number(n).toFixed(0)}`;
  return `${money(rate.rate)}/mo — your ${money(rate.credit)} ${String(source || "").trim() || "member"} credit applied`;
}
